module.exports = __webpack_public_path__ + "media/images/costumes/top/jewelry-ce0d99d8ae76003a514db648594c0939.jpg";